import React from "react";
import classNames from "classnames";

import { Skeleton } from "@common/skeleton";
import { ListToggleArrow } from "@common/listToggleArrow";
import { RecordList } from "../recordList";
import { Props } from "./types";
import { Task } from "./task";
import styles from "./styles.scss";

function List(_: Props) {
  return (
    <div className={styles.list}>
      <div className={styles.main}>
        <div className={styles.header} style={{ paddingLeft: `10rem` }}>
          <div className={styles.iconBox}>
            <ListToggleArrow isOpen={true} />
          </div>
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.recordList}>
          <RecordList type="list" />
        </div>
      </div>
      <Task />
    </div>
  );
}

export { List };
